import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(({ breakpoints }: Theme) => ({
  root: {
    listStyle: 'none',
    margin: 0,
    padding: 0,
    display: 'grid',
    rowGap: '2rem',
    [breakpoints.up('lg')]: {
      gridTemplateColumns: 'repeat(3, 1fr)',
      rowGap: '4rem',
      columnGap: '1.5rem',
    },
  },
  listItem: {
    width: '100%',
  },
}));
